import { GymTypes } from 'fitbeat.models';
import { SessionSequenceEntry, UserExerciseSession, WorkoutSettings } from '../../entities';
import { CardioOrResistance, Exercise, ExerciseFormat } from '../../entities/exercise';
import { Delays } from '../../entities/exercise/delays';
import { SessionSequence } from '../../entities/workoutsession/sessionsequence';
import { BalanceFlashCombo } from './balanceFlashCombo';
import { Build1FlashCombos } from './build1flashcombos';
import { Burn1FlashCombos } from './burn1flashcombos';
import { Burn2Endurance } from './burn2endurance';
import { HeroZonePunches } from './herozonepunches';
import { BalanceQuad } from './home/balanceQuad';
import { BuildDoubleDouble3Min } from './home/builddoubledouble3min';
import { BuildDoubleDouble4Min } from './home/buildDoubleDouble4Min';
import { BuildQuadSuperset4Min } from './home/BuildQuadSuperset4Min';
import { BuildQuadSupersetQuicksetup4Min } from './home/BuildQuadSupersetQuicksetup4Min';
import { BuildTripple3Min } from './home/buildtripple3min';
import { BurnDoubleDouble3Min } from './home/burndoubledouble3min';
import { BurnQuadSuperset3Min } from './home/BurnQuadSuperset3Min';
import { BurnQuadSupersetQuicksetup3Min } from './home/BurnQuadSupersetQuicksetup3Min';
import { BurnTripple3Min } from './home/burntripple3min';
import { HomeBuildQuarterSetup } from './home/homeBuildQuarterSetup';
import { HomePauseAtHalfwayBreak } from './home/homepauseathalfwaybreak';
import { HomePauseAtWorkoutStarting } from './home/homepauseatworkoutstarting';
import { HomeWarmdown } from './home/homewarmdown';
import { HomeWarmup } from './home/homewarmup';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';
import { MachineEndAndStretch } from './machineEndAndStretch';
import { MachineSetupAndStretch } from './machineSetupAndStretch';
import { MachineTrain } from './machinetrain';
import { PauseAtHalfwayBreak } from './pauseathalfwaybreak';
import { PauseAtWorkoutStarting } from './pauseatworkoutstarting';
import { StudioEmptyWithoutAudioBeeps } from './StudioEmptyWithoutAudioBeeps';
import { Warmdown } from './warmdown';
import { Warmup } from './warmup';
import { FunctionalStaticSequence } from './functionalStaticSequence';
import { isStaticFunctionalZone, WorkoutType } from '../../config';

export class SessionSequenceStrategyContext {
    public static sessionSequenceStrategies: Map<ExerciseFormat, ISessionSequenceStrategy> = new Map([
        [ExerciseFormat.StudioEmpty, new StudioEmptyWithoutAudioBeeps()],
        [ExerciseFormat.Build1FlashCombos, new Build1FlashCombos()],
        [ExerciseFormat.Burn1FlashCombos, new Burn1FlashCombos()],
        [ExerciseFormat.BalanceFlashCombo, new BalanceFlashCombo()],
        [ExerciseFormat.Burn2Endurance, new Burn2Endurance()],
        [ExerciseFormat.WarmupLowBuild, new Warmup()],
        [ExerciseFormat.WarmupModerateBuild, new Warmup()],
        [ExerciseFormat.WarmupLowBurn, new Warmup()],
        [ExerciseFormat.WarmupModerateBurn, new Warmup()],
        [ExerciseFormat.Warmdown30Hybrid, new Warmdown()],
        [ExerciseFormat.HeroZonePunches, new HeroZonePunches()],
        [ExerciseFormat.Build3BoxingEndurance, new Burn2Endurance()],
        [ExerciseFormat.PauseAtWorkoutStarting, new PauseAtWorkoutStarting()],
        [ExerciseFormat.PauseAtHalfwayBreak, new PauseAtHalfwayBreak()],
        [ExerciseFormat.WarmdownBuild, new Warmdown()],
        [ExerciseFormat.WarmdownBurn, new Warmdown()],
        [ExerciseFormat.WUBalanceHybrid, new Warmup()],
        [ExerciseFormat.WULowBalance, new Warmup()],
        [ExerciseFormat.WUModBalance, new Warmup()],
        [ExerciseFormat.WDBalance, new Warmdown()],
        [ExerciseFormat.WDBalanceStudio, new Warmdown()],
        [ExerciseFormat.MachineSetupAndStretch, new MachineSetupAndStretch()],
        [ExerciseFormat.MachineEndAndStretch, new MachineEndAndStretch()],
        [ExerciseFormat.MachineTrain, new MachineTrain()],
        [ExerciseFormat.StaticFunctional, new FunctionalStaticSequence()],
    ]);

    public static homeSessionSequenceStrategies: Map<ExerciseFormat, ISessionSequenceStrategy> = new Map([
        [ExerciseFormat.WarmupLowBuild, new HomeWarmup()],
        [ExerciseFormat.WarmupModerateBuild, new HomeWarmup()],
        [ExerciseFormat.WarmupHybridBuild, new HomeWarmup()],
        [ExerciseFormat.WarmupLowBurn, new HomeWarmup()],
        [ExerciseFormat.WarmupModerateBurn, new HomeWarmup()],
        [ExerciseFormat.WarmupHybridBurn, new HomeWarmup()],
        [ExerciseFormat.Warmdown30Hybrid, new HomeWarmdown()],
        [ExerciseFormat.PauseAtHalfwayBreak, new HomePauseAtHalfwayBreak()],
        [ExerciseFormat.HomeBreakBuild, new HomePauseAtHalfwayBreak()],
        [ExerciseFormat.HomeBreakBurn, new HomePauseAtHalfwayBreak()],
        [ExerciseFormat.WarmdownBuild, new HomeWarmdown()],
        [ExerciseFormat.WarmdownBurn, new HomeWarmdown()],

        [ExerciseFormat.BuildTripple3Min, new BuildTripple3Min()],
        [ExerciseFormat.BurnTripple3Min, new BurnTripple3Min()],

        [ExerciseFormat.BuildDoubleDouble3Min, new BuildDoubleDouble3Min()],
        [ExerciseFormat.BuildDoubleDouble4Min, new BuildDoubleDouble4Min()],
        [ExerciseFormat.BuildQuadSuperset4Min, new BuildQuadSuperset4Min()],
        [ExerciseFormat.BuildQuadSupersetQuicksetup4Min, new BuildQuadSupersetQuicksetup4Min()],
        [ExerciseFormat.BurnQuadSuperset3Min, new BurnQuadSuperset3Min()],
        [ExerciseFormat.BurnQuadSupersetQuicksetup3Min, new BurnQuadSupersetQuicksetup3Min()],
        [ExerciseFormat.BurnDoubleDouble3Min, new BurnDoubleDouble3Min()],

        [ExerciseFormat.HomeQuarterSetup, new HomeBuildQuarterSetup()],
        [ExerciseFormat.HomeBalanceQuad, new BalanceQuad()],
        [ExerciseFormat.WUBalanceHybrid, new HomeWarmup()],
        [ExerciseFormat.WDBalance, new HomeWarmdown()],
        [ExerciseFormat.HomeBreakBalance, new HomePauseAtHalfwayBreak()],

        [ExerciseFormat.PauseAtWorkoutStarting, new HomePauseAtWorkoutStarting()],
    ]);

    public static gymSessionSequences: Map<GymTypes, Map<ExerciseFormat, ISessionSequenceStrategy>> = new Map([
        [GymTypes.Home, SessionSequenceStrategyContext.homeSessionSequenceStrategies],
        [GymTypes.Outdoor, SessionSequenceStrategyContext.sessionSequenceStrategies],
    ]);

    public static getSessionSequence(
        exerciseFormat: ExerciseFormat,
        exercise: Exercise,
        alternativeExercise?: Exercise,
        gymType: GymTypes = GymTypes.Indoor,
        secondAlternativeExercise?: Exercise,
        thirdAlternativeExercise?: Exercise,
        zone?: number,
        quarter?: number,
        workoutSettings?: WorkoutSettings,
        previousExerciseSessions?: UserExerciseSession[],
        exerciseFormatDescription?: string,
        fastForwardXTimes?: number,
        ): SessionSequence[] {
        const emptyExercise = new Exercise('', '', [], false, [CardioOrResistance.Cardio], [], [], []);
        const exerciseOrEmpty = exercise || emptyExercise;
        const level = workoutSettings != null ? workoutSettings.level : undefined;

        const gymSessionSequences = this.gymSessionSequences.get(gymType) || this.sessionSequenceStrategies;
        const sessionSequence = gymSessionSequences && gymSessionSequences.get(exerciseFormat);
        if (sessionSequence) {
            const seqs = sessionSequence.getSessionSequence(
                exerciseOrEmpty, alternativeExercise, secondAlternativeExercise,
                thirdAlternativeExercise,
                zone, quarter, level, workoutSettings, previousExerciseSessions, exerciseFormatDescription);

            if (fastForwardXTimes && fastForwardXTimes > 1) {
                SessionSequenceStrategyContext.fastForward(seqs, fastForwardXTimes);
            }

            return seqs;
        }

        // default
        return new Burn2Endurance().getSessionSequence(
            exerciseOrEmpty, exerciseOrEmpty, exerciseOrEmpty, exerciseOrEmpty, zone as number, quarter as number);
    }

    public static getSessionSequenceForStudio(
        session: UserExerciseSession,
        gymType: GymTypes,
        workoutSettings?: WorkoutSettings,
    ): SessionSequence[] {
        const isSessionNeeded = (userSession: UserExerciseSession): boolean => {
            const isLongStaticFunctionalWorkout = isStaticFunctionalZone(userSession.parentWorkoutSession.areaCategory)
                && userSession.parentWorkoutSession.workoutType === WorkoutType.FullStudioWorkout;
            const isPowerWorkout = userSession.parentWorkoutSession.areaCategory === 'power';
            const isBoxingWorkout = userSession.parentWorkoutSession.areaCategory === 'boxing';
            return isLongStaticFunctionalWorkout || isPowerWorkout || isBoxingWorkout;
        }
        const shouldSendSession = session?.parentWorkoutSession
            && isSessionNeeded(session);
        return SessionSequenceStrategyContext.getSessionSequence(
          session.format,
          session.exercise,
          session.alternateExercise,
          gymType,
          session.secondAlternateExercise,
          session.thirdAlternateExercise,
          session?.zone.typeNumber,
          undefined, /*quarter*/
          workoutSettings,
          shouldSendSession
            ? [session]
            : undefined, /*previous exercise sessions*/
          undefined, /*exercise format description*/
          undefined, /*fast forward X times*/
        );
    }

    public static calculateTotalSeconds(sessionSequence: SessionSequence[]): number {
        return sessionSequence.reduce((totalSequence, sequence) => totalSequence + sequence.durationInMilliseconds, 0);
    }

    public static flattenSequence(sessionSequence: SessionSequence[]): SessionSequenceEntry[] {
        return sessionSequence.concat.apply([], sessionSequence.map(({ sequence }) => sequence));
    }

    public static getVoiceTipsDelays(exerciseFormat: ExerciseFormat, isBodyWeight = false,
                                     workoutDuration: number) {
        const defaultRestTipDelay = 500;
        const gymType = GymTypes.Home;
        const gymSessionSequences = this.gymSessionSequences.get(gymType) || this.sessionSequenceStrategies;
        const sessionSequence = gymSessionSequences && gymSessionSequences.get(exerciseFormat);
        if (sessionSequence) {
           return sessionSequence.getVoiceTipsDelaysNew ?
            sessionSequence.getVoiceTipsDelaysNew(workoutDuration) :
            sessionSequence.getVoiceTipsDelays ?
            sessionSequence.getVoiceTipsDelays(isBodyWeight) :
            new Delays(defaultRestTipDelay);
        }
        return  new Delays(defaultRestTipDelay);
    }

    private static fastForward(seqs: SessionSequence[], fastForwardTimes: number) {

        for (const s of seqs) {
            s.durationInMilliseconds
                = s.durationInMilliseconds / fastForwardTimes;
            s.sequence[0].durationInMilliseconds
                = s.sequence[0].durationInMilliseconds / fastForwardTimes;
        }
    }
}
